// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles__tooltip___3oet4","tooltip-trigger":"styles__tooltip-trigger___ucMSM","icon":"styles__icon___2uZ8C"};